<svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$props} >
<path d="M5 6H11V1H3V5" stroke="black"/>
<rect x="1" y="5" width="4" height="3" stroke="black"/>
</svg>